<template>
  <b-form-group
    :label="label"
    :class="mb0 ? 'mb-0' : ''"
  >
    <b-input-group class="input-group-merge">
      <b-input-group-prepend is-text>
        <feather-icon icon="SearchIcon" />
      </b-input-group-prepend>
      <b-form-input
        v-model="searchInput"
        :placeholder="placeholder"
        type="search"
      />
    </b-input-group>
  </b-form-group>
</template>

<script>
import {
  BInputGroup,
  BInputGroupPrepend,
  BFormInput,
  BFormGroup,
} from 'bootstrap-vue'

export default {
  components: {
    BInputGroup,
    BInputGroupPrepend,
    BFormInput,
    BFormGroup,
  },
  props: {
    label: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      required: false,
      default: 'Search',
    },
    mb0: {
      type: Boolean,
      required: false,
      default: false,
    },
    value: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
      searchInput: this.value,
      timer: null,
    }
  },
  watch: {
    value(newValue) {
      this.searchInput = newValue
    },
    searchInput(newValue) {
      this.$emit('input', newValue)
      if (this.timer) {
        clearTimeout(this.timer)
      }

      this.timer = setTimeout(() => {
        this.$emit('callback', newValue)
      }, 500)
    },
  },
  destroyed() {
    if (this.timer) {
      clearTimeout(this.timer)
    }
  },
}
</script>

<style>

</style>
